/* ts-quickview.js · Tom's Studio · Pipeline 8.1.1

   Picks the one image the quick view shows: the selected variant's own
   image, else the product's featured image, else the first. Rules in
   ts-quickview.css; loaded by the sections that render a quick-view
   trigger (ts-pick-grid, ts-for-your-pen), guarded so two loads bind once.

   Why a script: the theme renders every media item into the modal and,
   on a variant change, re-renders the title, price and form but skips the
   images (data-morph-skip) and only scrolls them - on desktop, never on
   phones. Nothing marks the selected one. So:

   - the variant -> media map comes from our own template snippet
     (ts-quickview-template), a JSON record per product keyed by handle,
     matched to the data-product-handle on the modal's product form.
   - the selected variant is the form's hidden input[name=id], which the
     theme keeps in step (x-model) and re-renders on every change.
   - a MutationObserver on the modal re-picks after the content is
     injected and after each variant morph. It runs before paint, so the
     wrong image never flashes. It watches content and the value
     attribute only, never class, so marking the hero can't re-trigger it.

   Only modals carrying .ts-qs-pop (ours) are touched. */
(function () {
  if (window.tsQuickviewHeroBound) return;
  window.tsQuickviewHeroBound = true;

  // Which product the modal is showing: the handle on its product form.
  // Not modal.id - the theme sets that from whichever trigger it last
  // wired, and on For your pen (many triggers) it was another product's,
  // so the lookup missed and the first image stayed (Jason, 13 Oct).
  function record(modal) {
    var form = modal.querySelector('form[data-product-handle]');
    if (!form) return null;
    var el = document.querySelector('script[data-ts-qv-media="' + form.getAttribute('data-product-handle') + '"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function pick(modal) {
    var slides = modal.querySelectorAll('[data-media-slide]');
    if (!slides.length) return;
    var map = record(modal);
    var input = modal.querySelector('input[name="id"]');
    var mediaId = map ? ((input && map.v[input.value]) || map.f) : null;
    var hero = (mediaId && modal.querySelector('[data-media-slide][data-media-id="' + mediaId + '"]')) || slides[0];
    for (var i = 0; i < slides.length; i++) {
      slides[i].classList.toggle('ts-qv-hero', slides[i] === hero);
    }
    modal.classList.add('ts-qv-ready');
  }

  var watched = typeof WeakSet === 'function' ? new WeakSet() : null;
  function watch(modal) {
    if (!modal.classList.contains('ts-qs-pop')) return;
    if (watched) { if (watched.has(modal)) return; watched.add(modal); }
    new MutationObserver(function () { pick(modal); }).observe(modal, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['value']
    });
    pick(modal);
  }

  function init() {
    var existing = document.querySelectorAll('[data-quickview-modal]');
    for (var i = 0; i < existing.length; i++) watch(existing[i]);
    // The theme appends its modal to <body> lazily, from the first trigger's template.
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && n.matches && n.matches('[data-quickview-modal]')) watch(n);
        }
      }
    }).observe(document.body, { childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
